const WHITESPACE_REGEX = /\s/

export default function containsWhitespace(str: string): boolean {
  return WHITESPACE_REGEX.test(str)
}
